<template>
  <div>

    <table width="100%">
      <tr>
        <td>
          <img v-bind:src="institue.Logo" style="width: 100px; height: 100px;">
        </td>
        <td width="60%" style="text-align: center">
          <h3 style="margin-bottom: 0px;">
            {{institue.Name}}
          </h3>
          <h3>Exam Admit Card</h3>
        </td>

        <td width="20%" style="text-align: right;">
          <div style="text-align: center; float:right">
            <img id="img" :src="admit.temp" style="width: 100px; height: 115px;" alt="profile-image">
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <hr />
        </td>
      </tr>
    </table>

    <table width="100%">
      <tr>
        <td width="80%">
          <table width="100%" style="margin-top: 0px; font-size: 14px;">

            <tr>
              <td>
                <table border="1" class="cell-padding" width="100%" style="border-collapse: collapse; font-size: 14px">
                  <tr>
                    <th colspan="4" class="bg" style="padding: 8"><label style="margin-top:25px">STUDENT INFORMATION</label></th>
                  </tr>
                  <tr>
                    <th class="bg" style="text-align:left" width="20%">Form No.</th>
                    <td align="left" width="30%">{{admit.rollnumber}}</td>
                    <th class="bg" style="text-align:left" width="20%">Applicant Name</th>
                    <td align="left" width="30%">{{admit.Name}}</td>

                  </tr>
                  <tr>
                    <th class="bg" style="text-align:left">Father Name</th>
                    <td align="left">{{admit.FatherName}}</td>
                    <th class="bg" style="text-align:left">Registration No</th>
                    <td align="left">{{admit.RegistrationNo}}</td>
                  </tr>

                </table>
              </td>
            </tr>

            <tr>
              <td>
                <br />
                <table class="cell-padding" border="1" width="100%" style="border-collapse: collapse; font-size: 14px">
                  <tr>
                    <th colspan="4" class="bg" style="padding: 8"><label style="margin-top:25px">EXAM INFORMATION</label></th>
                  </tr>
                  <tr>
                    <th class="bg" style="text-align:left" width="20%">Program & Session</th>
                    <td align="left" width="100%">{{admit.ProgramName}} - {{admit.SessionName}} </td>
                  </tr>
                  <tr>
                    <th class="bg" style="text-align:left" width="15">Courses</th>
                    <td align="left" colspan="3">
                      <ol>
                        <li v-for="(p,ind) in courses">
                          {{p.courseName}} - {{p.CourseCode}}
                        </li>
                      </ol>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <br />
                <table class="cell-padding" border="1" width="100%" style="border-collapse: collapse; font-size: 14px">
                  <tr>
                    <th class="bg" style="padding: 8"><label style="margin-top:25px">NOTE</label></th>
                  </tr>
                  <tr>
                    <td align="left">

                      <ol style="margin-top: 12px; margin-right: 12px;">
                        <li>Print of this Entrance Test Admit Card and Original Photo ID (CNIC / Passport / Domicile / Driving License) are compulsory to enter the Examination Hall.</li>
                        <li>
                          Report at the Exam Center 30 minutes before the starting time of the Test.
                        </li>
                        <li>Candidates who came 15 minutes after the start of the Test will be treated as Absent.</li>
                        <li>You are also required to bring a ball pen (black or blue) with you.</li>
                        <li>Face Mask and Hand Gloves are mandatory for all candidates.</li>
                        <li>Submit your Mobile phones/electronic devices/bags etc. at the designated collection counter before entering the Examination Hall. If found later, during the Test, it will be confiscated, and your test will immediately be canceled.</li>
                        <li> You may be checked physically before entering into Examination Hall.  </li>
                        <li> Candidates with a body temperature greater than 99 °F will not be allowed to enter the center. </li>
                      </ol>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        admit: {},
        courses: [],
        institue: [],
      }
    },
    created: function () {
      this.admitCard();
    },
    updated: function () {
    },
    methods: {
      admitCard() {
        var vm = this;
        axios.post('/api/ExamApi/AdmitCard')
          .then(function (response) {
            if (response.data.status) {
              vm.admit = response.data.admit;
              vm.courses = response.data.courses
              vm.institue = response.data.institue
            }
            else {
              toastr.error('No Attendance Found');
            }
          })
      }

    }
  })
</script>
<style>
  .bg {
    background-color: lightgrey;
  }

  .cell-padding tr td, th {
    padding: 2px;
  }

    #img {
    padding: 1px;
    border: 1px solid #021a40;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamAdmitCardPrint.vue